import angular from "angular";
import * as _ from "underscore";

import tpl from "./modalSearch.html";

/**
  * The top area of the search page for small screens
  *
  * This is the mobile counterpart to desktop-search
  *
  * It shows a minimal display of your current search: title and searchDescription
  *
  * On click it opens the full search interface as a modal dialog.

  * Including text, SRNO tabs and the search form
  * the search filters are all children of this
  */
/* @ngInject */
export function modalSearch(
  SearchActions,
  SearchQuery,
  modal,
  flux,
  SearchFilters,
  priceUtils,
  $location,
  $timeout
) {
  return {
    scope: true,
    templateUrl: tpl,
    link: function($scope, $element) {
      var $ = angular.element;
      $scope.modalIsOpen = false;

      function searchDescription() {
        var parts = [],
          q = SearchFilters.query;
        if (q.min_price || q.max_price) {
          var desc = priceUtils.description(
            q.min_price,
            q.max_price,
            SearchFilters.currencySymbol()
          );
          parts.push(desc);
        }
        // bedrooms
        if (q.bedrooms) {
          var _label = SearchFilters.descForFilter("bedrooms", q.bedrooms);
          if (_label !== "Studio") {
            _label += "BR";
          }
          parts.push(_label);
        }
        // bathrooms
        if (q.bathrooms) {
          var _label2 = SearchFilters.descForFilter("bathrooms", q.bathrooms);
          parts.push(_label2);
        }
        _.each(["periods", "neighborhoods", "types", "features"], function(
          key
        ) {
          _.each(SearchFilters.selectedOptionsDesc(key), function(word) {
            parts.push(word);
          });
        });
        if (parts.length) {
          return parts.join(" ");
        }
        return "Search by location, price, type, features >>";
      }

      function update() {
        $scope.srno = SearchFilters.pageMeta.srno;
        // the server provides a title for SEO
        // but we want a compact and succint one here
        $scope.title =
          SearchFilters.pageMeta.region + " " + SearchFilters.pageMeta.srno;
        $scope.searchDescription = searchDescription();
      }
      update();

      flux.onChanged(
        "search-form",
        function() {
          update(); // update description and title

          // search if its a new URL
          // but only iff modal is not open
          // (if modal is open then wait for user to click search)
          if (!$scope.modalIsOpen) {
            SearchActions.searchIfChanged();
          }
        },
        $scope
      );

      flux.onChanged(
        "search-query",
        function() {
          $scope.searchDescription = searchDescription();
        },
        $scope
      );

      // expose this controller api to children
      // for them to declare when they open
      // so that others may shut.
      // TODO: move to flux
      $scope.openFilter = function(key) {
        $scope.$broadcast("filter-did-open", key);
      };

      $scope.toggleModal = function(way) {
        $scope.modalIsOpen = way;
        modal("#modal-search", way);
        // store state somewhere
        flux.dispatch("set-page-store", {
          modalSearchIsOpen: way
        });
        if (!way) {
          // closing: OK search
          // change URL if needed,
          // just doing a replace
          var url = SearchQuery.buildUrl();
          $location.path(url).replace();
          // but do not let the controller fetch a new form
          $scope.openFilter(); // shut any that were open
          SearchActions.searchIfChanged();
        } else {
          // after open set max-height of .modal-search__filters
          // so that if the search form content exceeds the height
          // it will auto-scroll.
          $timeout(
            function() {
              var max =
                $(".modal-search__modal").height() -
                $(".modal-search__srno").height() -
                $(".modal-search__ok").height() -
                8;
              $element.find(".modal-search__filters").css("max-height", max);
            },
            1000,
            false
          );
        }
      };

      $scope.changeSr = function(sr) {
        if (sr !== $scope.srno) {
          $scope.srno = sr;
          SearchActions.changeSr(sr);
        }
      };
    }
  };
}
